import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'

import styles from './event-review-list-button.css'

const EventReviewListButton = ({ label }) => (
  <button styleName="event-review-list-button">
    {label}
  </button>
)

EventReviewListButton.propTypes = {
  label: PropTypes.string,
}

EventReviewListButton.defaultProps = {
  type: 'primary',
}

export default CSSModules(EventReviewListButton, styles, { allowMultiple: true })



/** WEBPACK FOOTER **
 ** ./src/components/event-review-list-button/event-review-list-button.js
 **/